module.exports = __webpack_public_path__ + "static/media/3.Portable Car Washer.4b872962.jpg";